export * from './pip-minimized';
